import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';

const styles = theme => ({
  root: {
    width: '100%',
  },
  container: {
    display: 'flex',
    flexFlow: 'row',
    flexWrap: 'row',
  },
  formControl: {
    margin: `${theme.spacing(1)}px auto`,
    maxWidth: 274,
    minWidth: 100,
    width: '100%',
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  formGroup: {
    margin: '0 auto',
  },
});

function withOption(list, value) {
  const options = Array.isArray(list) ? list : [];
  if (value === undefined || value === null || value === '') return options;
  if (options.some(item => String(item) === String(value))) return options;
  return options.concat(String(value));
}

function optionValue(list, value) {
  if (value === undefined || value === null || value === '') return '';
  const match = (list || []).find(item => String(item) === String(value));
  return match !== undefined ? match : value;
}

class SearchByMotoTireSize extends React.Component {
  handleWidthSelection = event => {
    this.props.onWidthChange(event.target.value);
  };

  handleProfileSelection = event => {
    this.props.onProfileChange(event.target.value);
  };

  handleRimSelection = event => {
    this.props.onRimChange(event.target.value);
  };

  render() {
    const {
      classes,
      widths,
      selectedWidth,
      profiles,
      selectedProfile,
      rims,
      selectedRim,
      idPrefix,
    } = this.props;

    const widthOptions = withOption(widths, selectedWidth);
    const profileOptions = withOption(profiles, selectedProfile);
    const rimOptions = withOption(rims, selectedRim);
    const widthId = `${idPrefix}-width`;
    const profileId = `${idPrefix}-profile`;
    const rimId = `${idPrefix}-rim`;

    const widthsMenuItems = widthOptions.map(width => (
      <MenuItem key={width.toString()} value={width}>
        {width}
      </MenuItem>
    ));

    const profilesMenuItems = profileOptions.map(profile => (
      <MenuItem key={profile.toString()} value={profile}>
        {profile}
      </MenuItem>
    ));

    const rimsMenuItems = rimOptions.map(rim => (
      <MenuItem key={rim.toString()} value={rim}>
        {rim}
      </MenuItem>
    ));

    return (
      <div className={classes.root}>
        <form className={classes.container} autoComplete="off">
          <FormGroup row className={classes.formGroup}>
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor={widthId}>רוחב</InputLabel>
              <Select
                value={optionValue(widthOptions, selectedWidth)}
                onChange={this.handleWidthSelection}
                inputProps={{
                  name: widthId,
                  id: widthId,
                }}
              >
                {widthsMenuItems}
              </Select>
            </FormControl>
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor={profileId}>חתך</InputLabel>
              <Select
                value={optionValue(profileOptions, selectedProfile)}
                onChange={this.handleProfileSelection}
                disabled={profileOptions.length === 0}
                inputProps={{
                  name: profileId,
                  id: profileId,
                }}
              >
                {profilesMenuItems}
              </Select>
            </FormControl>
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor={rimId}>חישוק</InputLabel>
              <Select
                value={optionValue(rimOptions, selectedRim)}
                onChange={this.handleRimSelection}
                disabled={rimOptions.length === 0}
                inputProps={{
                  name: rimId,
                  id: rimId,
                }}
              >
                {rimsMenuItems}
              </Select>
            </FormControl>
          </FormGroup>
        </form>
      </div>
    );
  }
}

SearchByMotoTireSize.propTypes = {
  classes: PropTypes.object,
  widths: PropTypes.array,
  profiles: PropTypes.array,
  rims: PropTypes.array,
  selectedWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectedProfile: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectedRim: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onWidthChange: PropTypes.func.isRequired,
  onProfileChange: PropTypes.func.isRequired,
  onRimChange: PropTypes.func.isRequired,
  idPrefix: PropTypes.string.isRequired,
};

SearchByMotoTireSize.defaultProps = {
  widths: [],
  profiles: [],
  rims: [],
  selectedWidth: '',
  selectedProfile: '',
  selectedRim: '',
};

export default withStyles(styles)(SearchByMotoTireSize);
